import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Route, Routes, useNavigate } from 'react-router-dom';
import { TabMenu } from 'primereact/tabmenu';
import { Button } from 'primereact/button';
import './App.css';

import CategoriaDataTable from './Categoria';
import Puntos from './Puntos';
import GestionPremio from './GestionPremio';
import GestionPreocupante from './GestionPreocupante';
import Canje from './Canje';
import Logos from './Logos';
import Login from './Login';
import Registro from './Registrar';
import ReportesRH from './ReportesRH';
import ReportesAdmin from './ReportesAdmin';
import ReporteVendedores from './ReporteVendedores';
import ResetPassword from './ResetPassword';
import ForgotPassword from './ForgotPassword';

export default function App() {
    const [isLoggedIn, setIsLoggedIn] = useState(false);
    const [username, setUsername] = useState('');
    const [cedulaEmpleado, setCedulaEmpleado] = useState('');
    const [userRoles, setUserRoles] = useState([]);
    const [isLoading, setIsLoading] = useState(true);
    const [activeItem, setActiveItem] = useState(null);
    const [filteredItems, setFilteredItems] = useState([]);

    const items = [
        { label: 'Puntometro', icon: 'pi pi-home', component: Logos },
        { label: 'Categoria', icon: 'pi pi-chart-line', component: CategoriaDataTable },
        { label: 'Puntos', icon: 'pi pi-list', component: Puntos },
        { label: 'Gestion de Premios', icon: 'pi pi-inbox', component: GestionPremio },
        { label: 'Gestion de Preocupantes', icon: 'pi pi-inbox', component: GestionPreocupante },
        { label: 'Canje', icon: 'pi pi-inbox', component: Canje },
        { label: 'Reportes', icon: 'pi pi-inbox', component: ReportesRH },
        { label: 'Reportes Admin', icon: 'pi pi-inbox', component: ReportesAdmin },
        { label: 'Reportes Vendedor', icon: 'pi pi-inbox', component: ReporteVendedores },
        { label: 'Olvidar Contraseña', icon: 'pi pi-inbox', component: ForgotPassword },
        { label: 'Restaurar Contraseña', icon: 'pi pi-inbox', component: ResetPassword }
    ];

    useEffect(() => {
        console.log('isLoggedIn:', isLoggedIn);
        console.log('username:', username);
        console.log('cedulaEmpleado:', cedulaEmpleado);
        console.log('userRoles:', userRoles);
    }, [isLoggedIn, username, cedulaEmpleado, userRoles]);

    useEffect(() => {
        const storedUsername = localStorage.getItem('username') || '';
        const storedCedulaEmpleado = localStorage.getItem('cedulaEmpleado') || '';
        const storedUserRoles = JSON.parse(localStorage.getItem('userRoles') || '[]');
        const storedActiveItem = JSON.parse(localStorage.getItem('activeItem'));
    
        if (storedUsername || storedCedulaEmpleado) {
            setIsLoggedIn(true);
            setUsername(storedUsername);
            setCedulaEmpleado(storedCedulaEmpleado);
            setUserRoles(storedUserRoles);
    
            if (storedActiveItem) {
                setActiveItem(storedActiveItem);
            }
        }
    
        setIsLoading(false);
    }, []);



    useEffect(() => {
        if (!isLoading && isLoggedIn) {
            const newFilteredItems = items.filter(item => {
                if (cedulaEmpleado) {
                    return item.label === 'Canje' || item.label === 'Reportes Vendedor' ;
                }

                if (userRoles.includes('ADMINISTRADOR')) {
                    return ['Categoria', 'Puntos', 'Gestion de Premios', 'Gestion de Preocupantes', 'Reportes Admin'].includes(item.label);
                }

                if (userRoles.includes('RRHH')) {
                    return ['Puntos', 'Reportes'].includes(item.label);
                }

                if (userRoles.includes('ALTO') || userRoles.includes('MEDIO') || userRoles.includes('BAJO')) {
                    return item.label === 'Puntos';
                }

                return false;
            });

            setFilteredItems(newFilteredItems);

            if ((!activeItem || !newFilteredItems.some(item => item.label === activeItem.label)) && newFilteredItems.length > 0) {
                const newActiveItem = newFilteredItems[0];
                setActiveItem(newActiveItem);
                localStorage.setItem('activeItem', JSON.stringify(newActiveItem));
            }
        }
    }, [isLoading, isLoggedIn, userRoles, cedulaEmpleado, activeItem]);

    const handleLogin = ({ username, cedulaEmpleado, roles }) => {
        setIsLoggedIn(true);
        setUsername(username || '');
        setCedulaEmpleado(cedulaEmpleado || ''); // Asegúrate de manejar un valor undefined
        const userRoles = Object.keys(roles);
        setUserRoles(userRoles);
        localStorage.setItem('username', username || '');
        localStorage.setItem('cedulaEmpleado', cedulaEmpleado || '');
        localStorage.setItem('userRoles', JSON.stringify(userRoles));
    };


    const handleLogout = () => {
        setIsLoggedIn(false);
        setUsername('');
        setCedulaEmpleado('');
        setUserRoles([]);
        setActiveItem(null);
        setFilteredItems([]);
        localStorage.clear();
    };

    const handleTabChange = (event) => {
        const newActiveItem = filteredItems[event.index];
        setActiveItem(newActiveItem);
        localStorage.setItem('activeItem', JSON.stringify(newActiveItem));
    };

    const renderTabComponent = () => {
        if (!activeItem) return null;

        switch (activeItem.label) {
            case 'Puntometro':
                return <Logos />;
            case 'Categoria':
                return <CategoriaDataTable />;
            case 'Puntos':
                return <Puntos loggedUserRoles={userRoles} />;
            case 'Gestion de Premios':
                return <GestionPremio />;
            case 'Gestion de Preocupantes':
                return <GestionPreocupante />;
            case 'Canje':
                return <Canje cedula_empleado={cedulaEmpleado} />;
            case 'Reportes':
                return <ReportesRH />;
            case 'Reportes Admin':
                return <ReportesAdmin />;
            case 'Reportes Vendedor':
                return <ReporteVendedores cedula_empleado={cedulaEmpleado} />;
            default:
                return null;
        }
    };

    return (
        <Router>
            <div className="app-container">
                {!isLoggedIn ? (
                    <Routes>
                        <Route path="/register" element={<Registro />} />
                        <Route path="/forgotPassword" element={<ForgotPassword />} />
                        <Route path="/resetPassword" element={<ResetPassword />} />
                        <Route path="/" element={<Login onLogin={handleLogin} />} />
                    </Routes>
                ) : (
                    <div>
                        <div className="tabmenu-container">
                            <div className="tabmenu-items">
                                <TabMenu model={filteredItems} activeIndex={filteredItems.indexOf(activeItem)} onTabChange={handleTabChange} />
                            </div>
                            <div className="logout-button">
                                <Button icon="pi pi-power-off" className="p-button-secondary p-button-icon" onClick={handleLogout} />
                            </div>
                        </div>
                        <div>
                        <p className="welcome-message">Bienvenido, <span className="username">{username || cedulaEmpleado}</span>!</p>
                            {activeItem && renderTabComponent()}
                        </div>
                    </div>
                )}
            </div>
        </Router>
    );
}
